import { NavItem } from "@/types";
import { memo } from "react";
import SectionLabel from "./SectionLabel";
import FullNavItem from "./FullNavItem";

const NavGroup = memo(({
  label, items, onItemClick,
}: {
  label: string;
  items: NavItem[];
  onItemClick?: () => void;
}) => (
  <div>
    <SectionLabel>{label}</SectionLabel>
    <div className="space-y-1">
      {items.map(item => (
        <FullNavItem key={item.href} item={item} onClick={onItemClick} />
      ))}
    </div>
  </div>
));

export default NavGroup;